
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Group_31322","data-name":"Group 31322","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 28.454 31.566"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"clip-path-add-features"}},[_c('path',{attrs:{"id":"Path_22132","data-name":"Path 22132","d":"M21.725 41.1a4.657 4.657 0 01-4.472-4.791V22.834a4.67 4.67 0 014.368-4.827h12.551a4.66 4.66 0 014.472 4.825v13.44a4.669 4.669 0 01-4.382 4.828","transform":"translate(-17.253 -18.006)","fill":"#44d4fc"}})])]),_c('path',{attrs:{"id":"Path_22133","data-name":"Path 22133","d":"M21.725 41.1a4.657 4.657 0 01-4.472-4.791V22.834a4.67 4.67 0 014.368-4.827h12.551a4.66 4.66 0 014.472 4.825v13.44a4.669 4.669 0 01-4.382 4.828","transform":"translate(-10.19 -18.006)","fill":"#864bf5"}}),_c('g',{attrs:{"id":"Group_31322-2","data-name":"Group 31322","transform":"translate(0 8.472)"}},[_c('path',{attrs:{"id":"Path_21005","data-name":"Path 21005","d":"M21.725 41.1a4.657 4.657 0 01-4.472-4.791V22.834a4.67 4.67 0 014.368-4.827h12.551a4.66 4.66 0 014.472 4.825v13.44a4.669 4.669 0 01-4.382 4.828","transform":"translate(-17.253 -18.006)","fill":"#44d4fc"}}),_c('g',{attrs:{"id":"Mask_Group_21746","data-name":"Mask Group 21746","clip-path":"url(#clip-path-add-features)"}},[_c('path',{attrs:{"id":"Path_22131","data-name":"Path 22131","d":"M21.725 41.1a4.657 4.657 0 01-4.472-4.791V22.834a4.67 4.67 0 014.368-4.827h12.551a4.66 4.66 0 014.472 4.825v13.44a4.669 4.669 0 01-4.382 4.828","transform":"translate(-10.19 -26.478)","fill":"#2cb1f7"}})]),_c('path',{attrs:{"id":"Union_85","data-name":"Union 85","d":"M0 1.667A7.694 7.694 0 014.147 0a8.617 8.617 0 014.325 1.667","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-width":"3"}})])])
          )
        }
      }
    